import isMobilePhone, { MobilePhoneLocale } from 'validator/lib/isMobilePhone';
import isURL from 'validator/lib/isURL';
import escape from 'validator/lib/escape';
import { z } from 'zod';

export const isValidPhone = (phone: string, locale: MobilePhoneLocale = 'en-US') => {
    return isMobilePhone(phone, locale);
};

export const formatZodError = <T extends z.ZodTypeAny>(error: z.ZodError) => {
    const response = z.flattenError(error);
    const keys = Object.keys(response.fieldErrors);
    return keys.reduce(
        (acc, key) => {
            acc[key] = response.fieldErrors[key as keyof T]?.[0] ?? '';
            return acc;
        },
        {} as Record<string, string>
    );
};

export const isValidUrl = (
    url: string,
    {
        allowEmpty = false,
        expectedDomains = []
    }: {
        allowEmpty?: boolean;
        expectedDomains?: string[];
    } = {}
): boolean => {
    if (!url && allowEmpty) return true;

    try {
        if (expectedDomains && expectedDomains.length > 0) {
            const urlLower = url.toLowerCase();
            const isValidDomain = expectedDomains.some(domain =>
                urlLower.includes(domain.toLowerCase())
            );
            if (!isValidDomain) return false;
        }

        return isURL(url, {
            protocols: ['http', 'https']
        });
    } catch {
        return false;
    }
};

export const sanitizeString = (str: string) => {
    return escape(str);
};
